import type { QueryParams } from "@common/types/api";
import { decamelizeKeys } from "humps";
import qs from "qs";

const buildUrlWithParams = (url: string, queryParams: QueryParams) => {
  const decamelizedQueryParams = decamelizeKeys(queryParams);
  const stringifiedQueryParams = qs.stringify(decamelizedQueryParams, {
    addQueryPrefix: true,
    allowEmptyArrays: true,
    arrayFormat: "brackets"
  });

  return `${url}${stringifiedQueryParams}`;
};

export default buildUrlWithParams;
